package com.flowyride.data.geocoding.photon

import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.model.Place

internal fun PhotonFeature.toPlaceOrNull(): Place? {
    val (longitude, latitude) = geometry.coordinates.takeIf { it.size >= 2 } ?: return null
    val point = runCatching { GeoPoint(latitude, longitude) }.getOrNull() ?: return null

    val streetLine = listOfNotNull(properties.housenumber, properties.street).joinToString(" ").ifBlank { null }
    val name = properties.name ?: streetLine ?: properties.city ?: return null
    val locality = listOfNotNull(properties.postcode, properties.city.takeIf { it != name })
        .joinToString(" ")
        .ifBlank { null }
    val detail = listOfNotNull(
        streetLine.takeIf { it != name },
        locality,
        properties.county.takeIf { it != name },
        properties.country,
    ).distinct().joinToString(", ").ifBlank { null }

    return Place(name = name, detail = detail, point = point)
}

/**
 * For a spot picked on the map, the nearest object is usually a road or an address:
 * the town reads better as a stop name ("Leschaux" rather than "Route du Semnoz").
 */
internal fun PhotonFeature.toPickedPlaceOrNull(): Place? {
    val place = toPlaceOrNull() ?: return null
    val city = properties.city
    if (properties.type !in ROAD_LEVEL_TYPES || city == null || city == place.name) return place
    val detail = listOfNotNull(place.name, properties.postcode, properties.county, properties.country)
        .joinToString(", ")
    return place.copy(name = city, detail = detail)
}

private val ROAD_LEVEL_TYPES = setOf("house", "street")
